import { useEffect, useState } from "react"

const StepperItem = ({ children, activeStep, step, renderAsync, index }) => {
    const [isVisible, setIsVisible] = useState()


    const animationActive = activeStep.direction === "right" ? "animate-fade-in-from-right" : "animate-fade-in-from-left"
    const animationInActive = activeStep.direction === "right" ? "animate-fade-out-to-left" : "animate-fade-out-to-right"



    useEffect(() => {
        let timeout
        if ((renderAsync || step.renderAsync) && index !== activeStep.index) {
            timeout = setTimeout(() => {
                setIsVisible(false)
            }, 250)

        } else {
            if (timeout) clearTimeout(timeout)
            setIsVisible(true)
        }

        return () => {
            if (timeout) clearTimeout(timeout)
        }
    }, [step.renderAsync, index, activeStep])

    return <div className={`${activeStep.index === index ? "z-[20] opaciy-100 " + animationActive : "absolute left-0 top-0 z-[10] opacity-0 " + animationInActive} w-full shrink-0 duration-300`}>
        {isVisible && children}
    </div>
}

export default StepperItem